import { useState } from "react"
import { Outlet, useLocation } from "react-router-dom"
import { Sidebar } from "./sidebar"
import { Topbar } from "./topbar"
import { SearchPalette } from "@/components/shared/search-palette"
import { ErrorBoundary } from "@/components/shared/error-boundary"
import { TrialBanner } from "@/components/trial-banner"
import { FeedbackWidget } from "@/components/feedback-widget"
import { BlurFade } from "@/components/ui/blur-fade"
import { cn } from "@/lib/utils"

const STORAGE_KEY = "hivehook_sidebar_collapsed"

export function RootLayout() {
  const [collapsed, setCollapsed] = useState(() => {
    return localStorage.getItem(STORAGE_KEY) === "true"
  })
  const location = useLocation()

  const toggle = () => {
    const next = !collapsed
    setCollapsed(next)
    localStorage.setItem(STORAGE_KEY, String(next))
  }

  return (
    <div className="min-h-screen">
      <SearchPalette />
      <Sidebar collapsed={collapsed} onToggle={toggle} />
      <div
        className={cn(
          "transition-[margin-left] duration-300 ease-in-out",
          collapsed ? "ml-16" : "ml-55",
        )}
      >
        <div className="sticky top-0 z-20 bg-background">
          <TrialBanner />
          <Topbar />
        </div>
        <main className="p-8 max-w-screen-2xl mx-auto">
          <ErrorBoundary>
            <BlurFade key={location.pathname} duration={0.3} offset={4} blur="4px">
              <Outlet />
            </BlurFade>
          </ErrorBoundary>
        </main>
      </div>
      <FeedbackWidget />
    </div>
  )
}
